import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigCatFlagsModel } from 'src/app/models/configCatFlagsModel';
import { JavaBaseResponse } from 'src/app/models/shift-management-models/java-base-response';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigCatService {
  private readonly _shiftJavaUri = this._utilService.getShiftUri();

  constructor (
    private _http: HttpClient,
    private _utilService: UtilsService
  ) { }

  getFeatureFlag(featureFlagName: string, uid: number): Observable<boolean> {
    return this.fetch`${featureFlagName}/${uid}`.pipe(
      map(response => response.data[featureFlagName]),
    );
  }

  getFeatureFlagByCid(flagName: string, cid: number, uid: number) {
    return this.fetch`${flagName}/clientId/${cid}/userId/${uid}`.pipe(
      map(response => response.data),
    );
  }

  /**
   * Tagged Template Literal method to make http requests for feature flags
   * 
   * @returns An observable for the request
   */
  private fetch(strings: TemplateStringsArray, ...values: any[]) {
    let url = this._shiftJavaUri + '/feature/';
    for (let i = 0; i < strings.length; ++i) {
      url += strings[i];
      if (values && values[i]) {
        url += values[i];
      }
    }
    return this._http.get<JavaBaseResponse<ConfigCatFlagsModel>>(url).pipe(
      catchError(error => throwError(`API and Params: ${url}: ${error.message}`))
    );
  }
}
